import { useTranslations } from "next-intl"
import IconCatalogue from "@/assets/img/Icon_Catalogue.svg"
import IconSaved from "@/assets/img/Icon_Saved-on.svg"
import { useEffect, useState } from "react"
import { useUserStore } from "@/stores/useUserStore"
import SwitchButton from "@/components/UI/Buttons/SwitchButton/SwitchButton"
import { useRouter } from "@/i18n/navigation"

export default function FavoritesFilter({ update, resetSignal, initialValue = false }: { update: (name: string, value: string) => void, resetSignal: number, initialValue: boolean}) {
    const t = useTranslations("Catalogue")
    const router = useRouter()
    const [favorites, setFavorites] = useState(initialValue)
    const { userId, profileId } = useUserStore()

    useEffect(() => {
        if(!favorites) update('favorite', '')
        else update('favorite', 'favorite=' + favorites)
    }, [favorites])

    useEffect(() => {
        setFavorites(initialValue)
    }, [initialValue])
    
    useEffect(() => {
        setFavorites(initialValue)
    }, [resetSignal])

    return (
        <SwitchButton
            firstOption={t('switchCatalogue')}
            secondOption={t('switchSaved')}
            firstSelected={!favorites}
            firstOptionIcon={IconCatalogue}
            secondOptionIcon={IconSaved}
            firstOptionCallback={() => setFavorites(false)}
            secondOptionCallback={() => setFavorites(true)}
            secondDisabled={!userId || !profileId}
            secondTooltip={!userId || !profileId}
            secondTooltipProps={{
                text: t('savedTooltipText'),
                buttonLabel: t('savedTooltipButtonText'),
                onAction: () =>  router.push('/login')
            }}/>
    )
}